import { Construtor } from './construtor';
import { Usuario } from './usuario';

export class DashboardUsuario implements Construtor<DashboardUsuario> {

    public idDashboardUsuario: number;
    public idDashboard: number;
    public usuario: Usuario;
    public visualizar: boolean;
    public alterar: boolean;

    constructor(object?: any) {
        this.usuario = new Usuario();
        if (object !== undefined) {
            if (object instanceof (DashboardUsuario)) {
                this.copyObject(object);
            } else if (object instanceof (Usuario)) {
                this.usuario = new Usuario(object);
            } else {
                this.parseFromJson(object);
            }
            if (!this.modeloCompleto()) {
                return null;
            }
        }
    }

    parseFromJson(object: any): void {
        this.idDashboardUsuario = object.idDashboardUsuario;
        this.idDashboard = object.idDashboard;
        this.usuario = object.usuario;
        this.visualizar = object.visualizar;
        this.alterar = object.alterar;
    }

    copyObject(dashboard: DashboardUsuario): void {
        this.idDashboardUsuario = dashboard.idDashboardUsuario;
        this.idDashboard = dashboard.idDashboard;
        this.usuario = dashboard.usuario;
        this.visualizar = dashboard.visualizar;
        this.alterar = dashboard.alterar;
    }

    modeloCompleto(): boolean {
        return this.idDashboard !== undefined && this.usuario !== undefined;
    }

    getNewInstance(object?: any): DashboardUsuario {
        return new DashboardUsuario(object);
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/dashboard-usuario.ts